var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.544,
    height: 64.544,
    viewBox: "0 0 64.544 64.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #192a40;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-102",
    transform: "translate(-64 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    className: "cls-1",
    d: "M96.272,128.544a32.272,32.272,0,1,1,32.272-32.272A32.308,32.308,0,0,1,96.272,128.544Zm0-61.47a29.2,29.2,0,1,0,29.2,29.2A29.231,29.231,0,0,0,96.272,67.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    className: "cls-1",
    d: "M482.305,667.926m-2.305,0a2.305,2.305,0,1,0,2.305-2.305A2.305,2.305,0,0,0,480,667.926Z",
    transform: "translate(-386.033 -558.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    className: "cls-1",
    d: "M492.2,270.668a1.537,1.537,0,0,1-1.537-1.537V246.656a1.537,1.537,0,0,1,3.074,0v22.475a1.537,1.537,0,0,1-1.537,1.537Z",
    transform: "translate(-395.931 -168.073)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp102);
export default __webpack_public_path__ + "static/media/help-102.a66bfa9c669983cabf16935e2645d9ea.svg";
export { ForwardRef as ReactComponent };